'use strict';

module.exports = function sum(key) {
  var total = 0;

  if (key === undefined) {
    for (var i = 0, length = this.items.length; i < length; i += 1) {
      total += this.items[i];
    }
  } else if (typeof key === 'function') {
    for (var _i = 0, _length = this.items.length; _i < _length; _i += 1) {
      total += key(this.items[_i]);
    }
  } else {
    for (var _i2 = 0, _length2 = this.items.length; _i2 < _length2; _i2 += 1) {
      total += this.items[_i2][key];
    }
  }

  return total;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/sum.js
// module id = 1279
// module chunks = 2